import {
    convertFromProtobufOrderSide,
    convertFromProtobufOrderSpotType,
    convertFromProtobufOrderState,
    convertFromProtobufPendingStrategy,
    convertFromProtobufPriceType,
} from '../helpers/protobuf';
import { IForwardOrderReport, IPendingOrderReport, ISpotOrderReport } from '../interfaces';
import { ISO8601 } from '@alk/dates';
import { OrderState, OrderType, PendingStrategy, PriceType, TradeSide } from 'sfx-web-contract';

export const DATA_01: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    valueDate: '2020-07-30' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.26212123,
    filledPrice: 1.26212,
    tradeDate: '2020-06-20' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745843490',
    clientName: 'Acme Corp',
};

export const DATA_02: ISpotOrderReport = {
    traderId: 'CAR-Wonka',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 2,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_IOC),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 1000000,
    counterCurrency: 'USD',
    counterFilledAmount: 631060,
    leftAmount: 500000,
    filledAmount: 500000,
    requestedPrice: 1.2621,
    filledPrice: 1.26212,
    tradeDate: '2020-06-20' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745844379',
    clientName: 'Wonka Candy',
};

export const DATA_03: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_PARTIALLY_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_MARKET),
    fillPercent: 10,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 105000,
    counterCurrency: 'USD',
    counterFilledAmount: 132522,
    leftAmount: 0,
    filledAmount: 105000,
    requestedPrice: 1.26212123,
    filledPrice: 1.26212,
    tradeDate: '2020-06-20' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745843905',
    clientName: 'Acme Corp',
};

export const DATA_04: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_CANCELLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 10,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    requestedAmount: 100000,
    counterCurrency: 'USD',
    counterFilledAmount: 126212,
    leftAmount: 0,
    filledAmount: 100000,
    requestedPrice: 1.26212123,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745842201',
    clientName: 'Acme Corp',
};

export const DATA_05: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_REJECTED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_IOC),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'USD',
    requestedAmount: 17150.75,
    counterCurrency: 'ILS',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 17150.75,
    requestedPrice: 1.2621,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745846501',
    clientName: 'Acme Corp',
};

export const DATA_06: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 3,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_UNKNOWN),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 20,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 3.430002,
    filledPrice: 3.430002,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745842622',
    clientName: 'Acme Corp',
};

export const DATA_07: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_INACTIVE),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_IOC),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'ILS',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.2621,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745843065',
    clientName: 'Krusty Krab',
};

export const DATA_08: ISpotOrderReport = {
    traderId: '123-123456',
    traderName: 'Aperture',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_STOP),
    fillPercent: 0,
    valueDate: '2020-04-20' as ISO8601,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.2621123,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745842641',
    clientName: 'Acme Corp',
};

export const DATA_09: ISpotOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_PARTIALLY_CANCELLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.26217777,
    filledPrice: 1.26217777,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576745847777',
    clientName: 'Acme Corp',
};

export const FWD_DATA_01: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'forward',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_REJECTED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    nearAmount: 10000,
    nearPrice: 1.2621,
    nearPoints: 3.5,
    tradeDate: '2020-06-21' as ISO8601,
    orderId: 'fwd_019922',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const FWD_DATA_02: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'forward',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_SUSPENDED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    nearAmount: 10000,
    nearPrice: 1.2321,
    nearPoints: 3.7,
    nearValueDate: '2020-06-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'fwd_019933',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const FWD_DATA_03: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'forward',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'EUR',
    nearAmount: 10000,
    nearPrice: 1.3521,
    nearPoints: 1.3,
    nearValueDate: '2020-07-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'fwd_019944',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const FWD_DATA_04: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'forward',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'USD',
    nearAmount: 10000,
    nearPrice: 1.35217777,
    nearPoints: 1.37777,
    nearValueDate: '2020-06-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'fwd_019977',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const SWAP_DATA_01: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'swap',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_REJECTED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    nearAmount: 10000,
    nearPrice: 1.2621,
    nearPoints: 3.5,
    nearValueDate: '2020-06-21' as ISO8601,
    farAmount: 10000,
    farPrice: 1.2631,
    farPoints: 2.5,
    farValueDate: '2020-06-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'swap_019822',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const SWAP_DATA_02: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'swap',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'USD/ILS',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'ILS',
    nearAmount: 10000,
    nearPrice: 1.2321,
    nearPoints: 3.7,
    nearValueDate: '2020-06-21' as ISO8601,
    farAmount: 10000,
    farPrice: 1.2331,
    farPoints: 2.7,
    farValueDate: '2020-07-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'swap_019833',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const SWAP_DATA_03: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'swap',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'EUR',
    nearAmount: 10000,
    nearPrice: 1.3521,
    nearPoints: 1.3,
    nearValueDate: '2020-07-21' as ISO8601,
    farAmount: 10000,
    farPrice: 1.3731,
    farPoints: 2.3,
    farValueDate: '2020-08-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'swap_019844',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const SWAP_DATA_04: IForwardOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'swap',
    clientId: 1,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_FILLED),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_FULL),
    fillPercent: 0,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'USD',
    nearAmount: 10000,
    nearPrice: 1.35217777,
    nearPoints: 1.37777,
    nearValueDate: '2020-07-21' as ISO8601,
    farAmount: 10000,
    farPrice: 1.37317777,
    farPoints: 2.37777,
    farValueDate: '2020-08-21' as ISO8601,
    tradeDate: '2020-06-21' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: 'swap_019877',
    clientName: 'Acme Corp',
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    spotRate: 1.3,
    farCounterFilledAmount: 13000,
};

export const PENDING_DATA_01: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Aperture',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_LIMIT),
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_SINGLE_ORDER),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_LIMIT),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143065',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_02: IPendingOrderReport = {
    traderId: '123-123457',
    traderName: 'wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_LIMIT),
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_SINGLE_ORDER),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_LIMIT),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143155',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_03: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Aperture',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_LIMIT),
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_SINGLE_ORDER),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_LIMIT),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143073',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_04: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Aperture',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_LIMIT),
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_SINGLE_ORDER),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_LIMIT),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143074',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_05: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Aperture',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_LIMIT),
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_SINGLE_ORDER),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_LIMIT),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143075',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_06: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_ACTIVE),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_STOP),
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_SINGLE_ORDER),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_STOP),
    fillPercent: 50,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22Z' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143076',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_07: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_OCO),
    pendingStrategyId: 'OCO123',
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_OCO),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_LIMIT),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_BUY),
    baseCurrency: 'USD',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143077',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const PENDING_DATA_08: IPendingOrderReport = {
    traderId: '123-123456',
    traderName: 'Wonka',
    userExtRefId: 'extRefId_0',
    orderType: 'spot',
    clientId: 4,
    state: convertFromProtobufOrderState(OrderState.ORDERSTATE_EXECUTING),
    spotType: convertFromProtobufOrderSpotType(OrderType.ORDERTYPE_OCO),
    pendingStrategyId: 'OCO123',
    pendingStrategy: convertFromProtobufPendingStrategy(PendingStrategy.PENDINGSTRATEGY_OCO),
    pendingLegType: convertFromProtobufPriceType(PriceType.PRICETYPE_STOP),
    fillPercent: 0,
    valueDate: '2020-04-02' as ISO8601,
    instrument: 'EUR/USD',
    side: convertFromProtobufOrderSide(TradeSide.TRADESIDE_SELL),
    baseCurrency: 'EUR',
    requestedAmount: 10000,
    counterCurrency: 'USD',
    counterFilledAmount: 12621,
    leftAmount: 0,
    filledAmount: 10000,
    requestedPrice: 1.083955,
    filledPrice: 1.26212,
    tradeDate: '2020-06-21T10:38:22' as ISO8601,
    executionDate: '2020-06-20' as ISO8601,
    orderId: '576723143078',
    expiryType: 'gtc',
    clientName: 'Krusty Krab',
};

export const ARRAY_OF_MIXED_ORDERS_01 = [
    DATA_01,
    DATA_02,
    DATA_03,
    DATA_04,
    DATA_05,
    DATA_06,
    DATA_07,
    DATA_08,
    DATA_09,
    FWD_DATA_01,
    FWD_DATA_02,
    FWD_DATA_03,
    FWD_DATA_04,
    SWAP_DATA_01,
    SWAP_DATA_02,
    SWAP_DATA_03,
    SWAP_DATA_04,
    PENDING_DATA_01,
    PENDING_DATA_02,
    PENDING_DATA_03,
    PENDING_DATA_04,
    PENDING_DATA_05,
    PENDING_DATA_06,
    PENDING_DATA_07,
    PENDING_DATA_08,
];
